import React from 'react';
import { Typography } from '@mui/material';
import '../../style/Login.css';

interface PermissionDeniedProps {
}

const PermissionDenied: React.FC<PermissionDeniedProps> = () => {
    return (
        <>
            <Typography className='login_typography_title'>
                Permission denied
            </Typography>
            <Typography className='login_typography_content'>
                You are not allowed to use the application.
            </Typography>
            <Typography className='login_typography_content'>
                If you have any question, please <span className='login_mark'>try another account</span> or <span className='login_mark'>contact your organization's administrator.</span>
            </Typography>
        </>
    );
};

export default PermissionDenied;
